// src/utils/imageInfo.js
//
// The pixel size of an uploaded picture, read in the browser. A browser can't
// see a picture's resolution setting, so the cover checks compare pixels with
// the print size: sharp print needs 300 pixels per inch.

/** { widthPx, heightPx }, or null when the browser can't show this picture (TIFF, mostly). */
export function readImageSize(file) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const picture = new Image();
    picture.onload = () => {
      resolve({ widthPx: picture.naturalWidth, heightPx: picture.naturalHeight });
      URL.revokeObjectURL(url);
    };
    picture.onerror = () => {
      resolve(null);
      URL.revokeObjectURL(url);
    };
    picture.src = url;
  });
}
